// Ochi 'Combínalo con' cross-sell — Cyber 2026
(function() {
  if (window.__ochiCombinaLoaded) return;
  window.__ochiCombinaLoaded = true;

  var path = location.pathname;
  var m = path.match(/^\/products\/([^\/]+)/);
  if (!m) return;
  var handle = m[1];

  // Pairs: handle → partner handle
  var PAIRS = {
    'chaqueta-slim-denim': 'jeans',
    'jeans': 'chaqueta-slim-denim',
    'pantalon-barrel': 'polera-manga-larga-escote-cuadrado',
    'polera-manga-larga-escote-cuadrado': 'pantalon-barrel'
  };

  var partnerHandle = PAIRS[handle];
  if (!partnerHandle) return;

  // Fetch partner product
  fetch('/products/' + partnerHandle + '.json', { credentials: 'same-origin' })
    .then(function(r){ return r.json(); })
    .then(function(data) {
      if (!data || !data.product) return;
      injectBlock(data.product);
    })
    .catch(function(){});

  function fmtCLP(amount) {
    var n = Math.round(parseFloat(amount));
    return '$' + n.toLocaleString('es-CL');
  }

  function injectBlock(partner) {
    injectStyles();
    function tryInject() {
      if (document.getElementById('ochi-combina')) return;

      // Try to find anchor point: after 'Comprar ahora' (shopify-payment-button)
      var anchor =
        document.querySelector('.shopify-payment-button') ||
        document.querySelector('[data-shopify="payment-button"]') ||
        document.querySelector('.product-form__buttons') ||
        document.querySelector('.product__info-wrapper') ||
        document.querySelector('.product-form');

      if (!anchor) { setTimeout(tryInject, 400); return; }

      // Get first image of partner
      var img = '';
      if (partner.images && partner.images.length) {
        img = partner.images[0].src || partner.images[0];
      } else if (partner.image && partner.image.src) {
        img = partner.image.src;
      }

      var minPrice = partner.variants && partner.variants.length
        ? Math.min.apply(null, partner.variants.map(function(v){ return parseFloat(v.price); }))
        : 0;

      var html =
        '<div id="ochi-combina">' +
          '<p class="oc-eyebrow">Combínalo con</p>' +
          '<a class="oc-card" href="/products/' + partner.handle + '">' +
            (img ? '<div class="oc-img"><img src="' + img + '" alt="' + (partner.title || '') + '" loading="lazy"></div>' : '<div class="oc-img oc-img--ph"></div>') +
            '<div class="oc-info">' +
              '<h3 class="oc-title">' + (partner.title || '') + '</h3>' +
              (minPrice ? '<p class="oc-price">' + fmtCLP(minPrice) + '</p>' : '') +
              '<span class="oc-cta">Ver pieza →</span>' +
            '</div>' +
          '</a>' +
        '</div>';

      var wrapper = document.createElement('div');
      wrapper.innerHTML = html;
      var el = wrapper.firstChild;

      // Insert after the anchor
      if (anchor.parentNode) {
        anchor.parentNode.insertBefore(el, anchor.nextSibling);
      }
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tryInject);
    else tryInject();
  }

  function injectStyles() {
    if (document.getElementById('ochi-combina-style')) return;
    var st = document.createElement('style');
    st.id = 'ochi-combina-style';
    st.appendChild(document.createTextNode(
      '#ochi-combina{margin:32px 0 16px;max-width:560px;font-family:inherit}' +
      '#ochi-combina .oc-eyebrow{font-size:11px;letter-spacing:2.5px;text-transform:uppercase;color:#888;margin:0 0 14px;font-weight:500}' +
      '#ochi-combina .oc-card{display:flex;align-items:center;gap:16px;padding:14px;border:1px solid #e5e2dd;background:#fff;text-decoration:none;color:inherit;transition:border-color .25s,transform .25s}' +
      '#ochi-combina .oc-card:hover{border-color:#232323}' +
      '#ochi-combina .oc-img{flex:0 0 80px;width:80px;height:110px;background:#f7f5f2;overflow:hidden}' +
      '#ochi-combina .oc-img img{width:100%;height:100%;object-fit:cover;display:block}' +
      '#ochi-combina .oc-info{flex:1}' +
      '#ochi-combina .oc-title{font-size:14px;font-weight:500;margin:0 0 6px;letter-spacing:.3px;text-transform:none;color:#232323;line-height:1.3}' +
      '#ochi-combina .oc-price{font-size:13px;color:#555;margin:0 0 10px}' +
      '#ochi-combina .oc-cta{font-size:11px;letter-spacing:1.5px;text-transform:uppercase;color:#232323;border-bottom:1px solid #232323;padding-bottom:2px;font-weight:500}'
    ));
    document.head.appendChild(st);
  }
})();
